import geoIPLookup from '../../../utilities/geoIPLookup';

import _ from '@rover/globals/underscore';
import Backbone from '@rover/globals/backbone';
import Rover from '@rover/globals/Rover';

export default Backbone.View.extend({
  initialize(options) {
    this.query = options.query;

    // Don't do anything if we already have a location or results
    const searchedQuery = this.model.get('query');
    if (searchedQuery) {
      const location = searchedQuery.location;
      if (location || this.model.allResultsCollection.length > 0) {
        return;
      }
    }

    this.geoIPLookup();
  },

  geoIPLookup() {
    if (!Object.prototype.hasOwnProperty.call(Rover, 'geoIPLookup')) {
      return;
    }

    geoIPLookup(_.bind(this.geoIPSuccessCallback, this));
  },

  geoIPSuccessCallback(lat, lng, name) {
    this.query.set({
      centerlat: lat,
      centerlng: lng,
      location: name,
    });
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/search_autofill_location_view.js